import { styled } from '@mui/material';
import React, { PropsWithChildren } from 'react';

interface PerkFormsWrapperProps extends PropsWithChildren {
    readOnly?: boolean;
}

const Fieldset = styled('fieldset')<PerkFormsWrapperProps>(({ disabled }) => ({
    border: 'none',
    padding: 0,
    margin: 0,
    ...(disabled && { opacity: 0.9, pointerEvents: 'none' })
}));

export const PerkFormsWrapper: React.FC<PerkFormsWrapperProps> = ({ children, readOnly }) => (
    <Fieldset disabled={readOnly}>{children}</Fieldset>
);
